import * as Sentry from '@sentry/angular';
import { environment } from '../../../environments/environment';
import { CHANGELOGS } from '../constants/changelog.constant';
import { buildSentryConfig } from './sentry.config';

/**
 * Initialise Sentry AVANT le bootstrap Angular (appelé en tête de main.ts)
 * pour capturer aussi les échecs de démarrage.
 *
 * No-op si le DSN runtime est vide (dev local, environnement sans Sentry)
 * ou hors navigateur (SSR). `initFn` est injectable pour les tests.
 */
export function initSentry(
  initFn: (options: Sentry.BrowserOptions) => unknown = Sentry.init
): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const config = buildSentryConfig(environment, CHANGELOGS[0]?.version);
  if (!config) {
    return false;
  }
  initFn(config);
  return true;
}
